import styled from 'styled-components';

export default styled.div`
  padding: 0 1rem 2rem;
`;
